import { ErrorsInterface } from "@pepdirect/shared/types";
import { logUnknownErrorCode } from "./logAndCaptureInSentry";

export const getMappedErrorMsg = (
  code: string,
  errorCodeMap: ErrorsInterface,
  operationName: string
): string => {
  const mappedErrorMsg = errorCodeMap[code];
  if (!mappedErrorMsg) {
    logUnknownErrorCode(code, operationName);
  }
  return mappedErrorMsg || "Something went wrong. Please try again.";
};
